module.exports = __webpack_public_path__ + "img/05.56f5cf43.png";